import * as React from 'react'
import { IServiceLocationObject } from 'src/types'
import UIMessages from 'src/utils/ui-messages'
import ServiceLocationListItem from './ServiceLocationListItem'

interface IServiceViewSuggestedLocationsProps {
  serviceId: string
  serviceSuggestedLocationList: IServiceLocationObject[]
  getSuggestedLocationList: (serviceId: string) => any
}

export const ServiceViewSuggestedLocations = (props: IServiceViewSuggestedLocationsProps) => {
  React.useEffect(() => {
    props.getSuggestedLocationList(props.serviceId)
  }, [props.serviceId])

  if (props.serviceId) {
    return (
      <div className='flex'>
        <div style={{ flex: 2 }}>
          <div className='flex'>
            <div className='col-1'>&nbsp;</div>
            <div className='col-2'>
              <span className='h5 font-grey2'>{UIMessages.common.nameLabel}</span>
            </div>
            <div className='col-2'>
              <span className='h5 font-grey2'>{UIMessages.common.phoneNumber}</span>
            </div>
            <div className='col-4'>
              <span className='h5 font-grey2'>{UIMessages.common.address}</span>
            </div>
            <div className='col-3'>
              <span className='h5 font-grey2'>{UIMessages.common.note}</span>
            </div>
          </div>
          <div className='bt-light-grey4'>&nbsp;</div>
          {props.serviceSuggestedLocationList.map((item, i) => (
            <ServiceLocationListItem key={`tmli-${i}`} location={item} />
          ))}
        </div>
        <div style={{ flex: 1 }}>&nbsp;</div>
      </div>
    )
  }
  return <div />
}

export default ServiceViewSuggestedLocations



// WEBPACK FOOTER //
// ./src/components/services/view/ServiceViewSuggestedLocations.tsx